import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "us-west-2",
    aws_cognito_identity_pool_id: "us-west-2:6c0f0fb6-93ed-4487-9204-2a38a791ff65",
    aws_user_pools_id: "us-west-2_nJQsirkaz",
    aws_user_pools_web_client_id: "42m0pks5ktm0ubvgcm8ibejh2p",
    Auth: {
      identityPoolId: "us-west-2:6c0f0fb6-93ed-4487-9204-2a38a791ff65",
      region: "us-west-2",
      userPoolId: "us-west-2_nJQsirkaz",
      userPoolWebClientId: "42m0pks5ktm0ubvgcm8ibejh2p",
    },
    oauth: {
      domain: "whs-safer-gamma-latam.auth.us-west-2.amazoncognito.com",
      redirectSignIn: "https://gamma.latam.safer.whs.amazon.dev",
      redirectSignOut: "https://gamma.latam.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
